import { apiRequest } from '../../lib/api.js';

export function renderCustomerProjects() {
    return `
    <section class="page-header" style="background: var(--color-surface-warm);">
      <div class="container">
        <h1 class="page-title">My Projects</h1>
        <p class="page-subtitle">Track your interior design projects in real-time</p>
      </div>
    </section>
    <section style="padding: var(--space-10) 0 var(--space-20);">
      <div class="container">
        <div id="projects-list" style="display:flex;flex-direction:column;gap:var(--space-6);">
          <div style="text-align:center;padding:var(--space-12);color:var(--color-text-muted);">
            <div class="loading-spinner" style="margin:0 auto var(--space-4);width:40px;height:40px;border:3px solid var(--color-border);border-top-color:var(--color-primary);border-radius:50%;animation:spin 1s linear infinite;"></div>
            <p>Loading your projects...</p>
          </div>
        </div>
      </div>
    </section>
    <style>@keyframes spin{to{transform:rotate(360deg)}}</style>
  `;
}

export function initCustomerProjects() {
    async function load() {
        try {
            const data = await apiRequest('/projects');
            const projects = data.data || [];
            const container = document.getElementById('projects-list');

            if (!projects.length) {
                container.innerHTML = `
          <div style="text-align:center;padding:var(--space-16);background:var(--color-surface);border-radius:var(--radius-xl);border:1px solid var(--color-border);">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-muted)" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/></svg>
            <h3 style="margin:var(--space-4) 0 var(--space-2);">No Projects Yet</h3>
            <p style="color:var(--color-text-muted);margin-bottom:var(--space-6);">Start your interior design journey with a free consultation!</p>
            <a href="/contact" class="btn btn-primary">Book Free Consultation</a>
          </div>
        `;
                return;
            }

            container.innerHTML = projects.map(p => {
                const statusColors = { quote: '#2196F3', design: '#9C27B0', approved: '#FF9800', manufacturing: '#FF5722', delivery: '#00BCD4', installation: '#4CAF50', completed: '#1B5E20', cancelled: '#9E9E9E' };
                const statusColor = statusColors[p.status] || '#666';
                const progress = { quote: 10, design: 25, approved: 40, manufacturing: 55, delivery: 70, installation: 85, completed: 100, cancelled: 0 };
                const pct = progress[p.status] || 0;

                return `
          <div style="background:var(--color-surface);border-radius:var(--radius-xl);border:1px solid var(--color-border);overflow:hidden;">
            <div style="padding:var(--space-6);">
              <div style="display:flex;justify-content:space-between;align-items:start;margin-bottom:var(--space-4);">
                <div>
                  <h3 style="margin:0;font-size:18px;">${p.title}</h3>
                  <p style="margin:4px 0 0;font-size:13px;color:var(--color-text-muted);">${p.address || ''}, ${p.city || ''}</p>
                </div>
                <span style="display:inline-block;padding:4px 12px;border-radius:var(--radius-full);font-size:12px;font-weight:600;color:white;background:${statusColor};text-transform:capitalize;">${(p.status || '').replace(/_/g, ' ')}</span>
              </div>

              <!-- Progress Bar -->
              <div style="margin-bottom:var(--space-4);">
                <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:4px;">
                  <span>Progress</span>
                  <span style="font-weight:600;">${pct}%</span>
                </div>
                <div style="height:6px;background:var(--color-border);border-radius:3px;overflow:hidden;">
                  <div style="height:100%;width:${pct}%;background:linear-gradient(90deg,${statusColor},${statusColor}dd);border-radius:3px;transition:width 0.5s ease;"></div>
                </div>
              </div>

              <!-- Details Grid -->
              <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:var(--space-3);font-size:13px;">
                <div><span style="color:var(--color-text-muted);">Property:</span> <strong>${(p.property_type || '').toUpperCase()}</strong></div>
                <div><span style="color:var(--color-text-muted);">Total:</span> <strong>₹${parseFloat(p.total_amount || 0).toLocaleString('en-IN')}</strong></div>
                <div><span style="color:var(--color-text-muted);">Paid:</span> <strong style="color:var(--color-success);">₹${parseFloat(p.paid_amount || 0).toLocaleString('en-IN')}</strong></div>
                ${p.designer_name ? `<div><span style="color:var(--color-text-muted);">Designer:</span> <strong>${p.designer_name}</strong></div>` : ''}
                ${p.start_date ? `<div><span style="color:var(--color-text-muted);">Started:</span> <strong>${new Date(p.start_date).toLocaleDateString()}</strong></div>` : ''}
                ${p.expected_end_date ? `<div><span style="color:var(--color-text-muted);">Expected:</span> <strong>${new Date(p.expected_end_date).toLocaleDateString()}</strong></div>` : ''}
              </div>
            </div>

            <!-- Milestones -->
            ${p.milestones && p.milestones.length ? `
              <div style="padding:var(--space-4) var(--space-6);background:var(--color-surface-warm);border-top:1px solid var(--color-border);">
                <p style="font-size:12px;font-weight:600;color:var(--color-text-muted);margin:0 0 var(--space-3);text-transform:uppercase;letter-spacing:0.5px;">Milestones</p>
                <div style="display:flex;gap:var(--space-4);overflow-x:auto;">
                  ${p.milestones.map(m => `
                    <div style="display:flex;align-items:center;gap:var(--space-2);flex-shrink:0;">
                      <div style="width:20px;height:20px;border-radius:50%;border:2px solid ${m.status === 'completed' ? 'var(--color-success)' : 'var(--color-border)'};background:${m.status === 'completed' ? 'var(--color-success)' : 'transparent'};display:flex;align-items:center;justify-content:center;">
                        ${m.status === 'completed' ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20,6 9,17 4,12"/></svg>' : ''}
                      </div>
                      <span style="font-size:12px;color:${m.status === 'completed' ? 'var(--color-success)' : 'var(--color-text-muted)'};">${m.title}</span>
                    </div>
                  `).join('')}
                </div>
              </div>
            ` : ''}
          </div>
        `;
            }).join('');
        } catch (e) {
            document.getElementById('projects-list').innerHTML = `
        <div style="text-align:center;padding:var(--space-8);color:var(--color-error);">
          <p>Failed to load projects. Please log in first.</p>
          <a href="/login" class="btn btn-primary" style="margin-top:var(--space-4);">Login</a>
        </div>
      `;
        }
    }
    load();
}
